import {
  OP_MODEL_MODES,
  type OpModelMode,
} from "@/components/codesmith/thread/opLog";
import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

export const REVIEW_TRIGGERS = [
  "push",
  "as_needed",
  "opened",
  "manual",
] as const;
export type ReviewTrigger = (typeof REVIEW_TRIGGERS)[number];

export const REVIEW_MODEL_MODES = OP_MODEL_MODES;
export type ReviewModelMode = OpModelMode;
export const REVIEW_MODEL_MODE_LABELS: Record<ReviewModelMode, string> = {
  fast: "Fast",
  deep: "Deep",
  fusion: "Fusion",
};

/** A member's review preferences for one org, every field resolved to its default by the backend. */
export type UserReviewSettings = {
  review_enabled: boolean;
  review_trigger: ReviewTrigger;
  review_model_mode: ReviewModelMode;
  review_publish: boolean;
  review_fix_draft_prs: boolean;
  review_max_rounds: number;
};

export type UserReviewSettingsUpdate = Partial<UserReviewSettings>;

const hooks = createUserOrgSettingsHooks<UserReviewSettings>({
  resource: "user-review-settings",
  errorMessage: "Failed to update review settings",
});

export const useUserReviewSettings = hooks.useSettings;
export const useUpdateUserReviewSettings = hooks.useUpdateSettings;
